import { hostedStagingAuthClient, hostedStagingAuthConfiguration, requestHostedStagingMagicLink } from "./hosted-staging-auth";

export const dataMode = hostedStagingAuthConfiguration?.environment.dataMode
  ?? (import.meta.env.VITE_DATA_MODE as string | undefined)
  ?? "synthetic";
export const supabase = hostedStagingAuthClient;

export async function signInWithGoogle() {
  if (!supabase) throw new Error("Supabase is not configured.");
  throw new Error("Google sign-in is not part of the hosted staging authentication rehearsal.");
}

export async function sendMagicLink(email: string) {
  if (!supabase) throw new Error("Supabase is not configured.");
  return requestHostedStagingMagicLink(supabase, email);
}
